module.exports = __webpack_public_path__ + "img/carpetaPhone.d610b6f7.png";